import moment from 'moment';
import { ICargo } from './interfaces';
export const useApi = (projectCode: string|undefined) => {
    return {
        projectCode: projectCode ? projectCode.toUpperCase() : 'DEF',
        getGeneralHeader() {
            if (!window.localStorage.getItem('token')) {
                window.location.href = `/web/login/${this.projectCode.toLowerCase()}`
                return
            }
            return {
                'Content-Type': 'application/json',
                'X-Access-Token': window.localStorage.getItem('token') || 'DummyToken',
                'X-Member-ID': window.localStorage.getItem('memberId') || 'Dummy'
            }
        },
        getMemberId() {
            return window.localStorage.getItem('memberId')
        },
        publicGet(endPoint: string, cb?: Function, apiVersion: number = 6) {
            fetch(`/api/v${apiVersion}/public${endPoint}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then((res) => {
                return res.status === 200 ? res.json() : { returnCode: res.status }
            })
            .then((cargo) => {
                if (cb !== undefined) {
                    cb(cargo)
                }
            })
        },
        publicPost(endPoint: string, body: any, cb?: Function, apiVersion: number = 6) {
            fetch(`/api/v${apiVersion}/public${endPoint}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            })
            .then((res) => {
                return res.status === 200 ? res.json() : { returnCode: res.status }
            })
            .then((cargo) => {
                if (cb !== undefined) {
                    cb(cargo)
                }
            })
        },
        privateGet(endPoint: string, cb?: Function, apiVersion: number = 6) {
            fetch(`/api/v${apiVersion}/private${endPoint}`, {
                method: 'GET',
                headers: this.getGeneralHeader(),
            })
            .then((res) => {
                return res.status === 200 ? res.json() : { returnCode: res.status }
            })
            .then((cargo) => {
                if (cb !== undefined) {
                    cb(cargo)
                }
            })
        },
        privateMethod(endPoint: string, method: string, body: any, cb?: Function, apiVersion: number = 6) {
            fetch(`/api/v${apiVersion}/private${endPoint}`, {
                method: method.toUpperCase(),
                headers: this.getGeneralHeader(),
                body: JSON.stringify(body)
            })
            .then((res) => {
                return res.status === 200 ? res.json() : { returnCode: res.status }
            })
            .then((cargo) => {
                if (cb !== undefined) {
                    cb(cargo)
                }
            })
        },
        privatePost(endPoint: string, body: any, cb?: Function, apiVersion: number = 6) {
            this.privateMethod(endPoint, 'POST', body, cb, apiVersion)
        },
        privatePatch(endPoint: string, body: any, cb?: Function, apiVersion: number = 6) {
            this.privateMethod(endPoint, 'PATCH', body, cb, apiVersion)
        },
        privatePut(endPoint: string, body: any, cb?: Function, apiVersion: number = 6) {
            this.privateMethod(endPoint, 'PUT', body, cb, apiVersion)
        },
        privateDelete(endPoint: string, body: any, cb?: Function, apiVersion: number = 6) {
            this.privateMethod(endPoint, 'DELETE', body, cb, apiVersion)
        },
        addUserCharacter(idCharacter: Number, cb?: Function) {
            this.privatePost(`/sns/characters/${this.getMemberId()}/${idCharacter}`, {}, cb)
        },
        archiveNft(nftId: string, cb?: Function) {
            this.privatePut(`/nft/assets/archive/${this.getMemberId()}/${nftId}`, {}, cb)
        },
        createNftSeries(title: string, cb?: Function) {
            this.privatePost(`/series/${this.getMemberId()}`, {title}, cb, 7)
        },
        createProduct(idCategory: number, price: Number, name: string, description: string, cover: string, cb?: Function) {
            this.privatePost(`/store/product/${this.getMemberId()}`, { idCategory, price, name, description, cover}, cb)
        },
        deleteFtxReservation(idFtxReservation: Number, cb?: Function) {
            this.privateDelete(`/partner/ftx/reservations/${this.getMemberId()}`, { idFtxReservation }, cb)
        },
        delUserCharacter(idCharacter: Number, cb?: Function) {
            this.privateDelete(`/sns/characters/${this.getMemberId()}/${idCharacter}`, {}, cb)
        },
        getBid(nftId: string, memberNo: string, cb?: Function) {
            this.publicGet(`/bid/${nftId}/${memberNo}`, cb, 7)
        },
        getBinanceTicker(currency: string, cb?: Function) {
            this.publicGet(`/partner/binance/ticker/${currency}`, cb);
        },
        getCharacters(cb?: Function) {
            this.publicGet(`/sns/characters/${this.projectCode}`, cb)
        },
        getChildrens(cb?: Function) {
            this.privateGet(`/core/referrals/childrens/${this.getMemberId()}`, cb)
          },
        getCoinInfo(cb?: Function) {
            this.privateGet(`/core/pvs/${this.getMemberId()}`, cb)
        },
        getCreatorProfile(memberNo: string, cb?: Function) {
            this.publicGet(`/creator/profile/${memberNo}`, cb, 7)
        },
        getProductCategory(projectCode: string, cb?: Function) {
            this.publicGet(`/store/product/category/${projectCode.toUpperCase()}`, cb)
        },
        getEthTransactions(cb?: Function) {
            this.privateGet(`/partner/eth/transactions/${this.getMemberId()}`, cb)
        },
        getFavoriteCryptos(cb?: Function) {
            this.privateGet(`/core/favorite/cryptos/${this.getMemberId()}`, cb);
        },
        getFtxAccountInfo(cb?: Function) {
            this.privateGet(`/partner/ftx/account/${this.getMemberId()}`, cb)
        },
        getFtxCompletedSubOrders(orderId: string, cb?: Function) {
            this.privateGet(`/partner/ftx/orders/completed/${this.getMemberId()}/${orderId}`, cb)
        },
        getFtxOrders(cb?: Function) {
            this.privateGet(`/partner/ftx/orders/${this.getMemberId()}`, cb)
        },
        getFtxReservation(cb?: Function) {
            this.privateGet(`/partner/ftx/reservations/${this.getMemberId()}`, cb)
        },
        getFtxAvailableStrategies(cb?: Function) {
            this.publicGet(`/partner/ftx/strategies`, cb)
        },
        getFtxStrategy(strtegy: string, cb?: Function) {
            this.publicGet(`/partner/ftx/strategies/${strtegy}`, cb)
        },
        getFtxStrategies(cb?: Function) {
            this.privateGet(`/partner/ftx/strategies/${this.getMemberId()}`, cb)
        },
        getGasTransaction(cb?: Function) {
            this.privateGet(`/core/exchanges/gas/${this.getMemberId()}`, cb)
        },
        getGasTopupTransaction(cb?: Function) {
            this.privateGet(`/core/exchanges/cc/gas/${this.getMemberId()}`, cb)
        },
        getGuestbooks(cb?: Function) {
            this.privateGet(`/sns/guestbooks/${this.getMemberId()}`, cb)
        },
        getKycStatus(cb?: Function) {
            this.privateGet(`/kyc/status/${this.getMemberId()}`, cb)
        },
        getLineNotifyStatus(cb?: Function) {
            this.privateGet(`/partner/line/notify/available/${this.getMemberId()}`, cb)
        },
        getMemberCount(cb?: Function) {
            this.publicGet('/core/profiles/count', cb)
        },
        getNftAsset(nftId: string, cb?: Function) {
            this.publicGet(`/nft/assets/${nftId}`, cb);
        },
        getNftAssetTrxHistories(nftId: string, cb?: Function) {
            this.publicGet(`/nft/assets/histories/${nftId}`, cb);
        },
        getNftAssets(cb?: Function) {
            this.publicGet(`/nft/assets`, cb);
        },
        getNftAssetsLast(number: number, cb?: Function) {
            this.publicGet(`/nft/assets/last/${number}`, cb);
        },
        getNftBidding(nftId: string, memberNo: string, cb?: Function) {
            this.publicGet(`/bidding/${nftId}/${memberNo}`, cb, 7);
        },
        getNftCreatorsAssets(referralCode: string, cb?: Function) {
            this.publicGet(`/nft/assets/creator/${referralCode}`, cb);
        },
        getNftFavorites(cb?: Function) {
            this.privateGet(`/nft/favorites/${this.getMemberId()}`, cb);
        },
        getNftFavoriteCount(nftId: string, cb?: Function) {
            this.publicGet(`/nft/favorites/count/${nftId}`, cb);
        },
        getNftHotFavorites(cb: Function) {
            this.publicGet('/nft/favorites/hot', cb)
        },
        getNftMetadata(contractAddress: string, nonce: string, cb?:Function) {
            this.publicGet(`/nft/metadata/${contractAddress}/${nonce}`, cb);
        },
        getNftSeries(memberNo: string, cb?: Function) {
            this.publicGet(`/series/${memberNo}`, cb, 7)
        },
        getNftTopTrades(number: number, cb: Function) {
            this.publicGet(`/nft/trade/hot/${number}`, cb)
        },
        getNftTrxHistories(cb?: Function) {
            this.privateGet(`/nft/trx/histories/${this.getMemberId()}`, cb);
        },
        getNnegoTransaction(cb?: Function) {
            this.privateGet(`/core/exchanges/nnego/${this.getMemberId()}`, cb)
        },
        getPledges(cb?: Function) {
            this.privateGet(`/investment/pledges/${this.getMemberId()}`, cb);
        },
        getProducts(projectCode: string, cb?: Function) {
            this.publicGet(`/store/products/${projectCode}`, cb);
        },
        getProductDetail(idProducts: string, cb?: Function) {
            this.publicGet(`/store/product/detail/${idProducts}`, cb);
        },
        getProfile(cb?: Function) {
            this.privateGet(`/core/profiles/${this.getMemberId()}`, cb);
        },
        getPublicProfile(simpleCode: string | null, cb?: Function) {
            this.publicGet(`/core/profiles/${simpleCode}`, cb);
        },
        getRedirectLinkForBusinessToday(cb?: Function) {
            this.privateGet(`/partner/businesstoday/redirect/${this.getMemberId()}`, cb, 7);
        },
        getReferralCode(cb?: Function) {
            this.privateGet(`/core/members/referral/${this.getMemberId()}`, cb)
        },
        getSelectedCreators(cb: Function) {
            this.publicGet('/nft/creators/selected', cb)
        },
        getSelectedNft(cb: Function) {
            this.publicGet('/nft/selected', cb)
        },
        getUsdtTransactions(cb?: Function) {
            this.privateGet(`/partner/usdt/transactions/${this.getMemberId()}`, cb)
        },
        getUserCharacters(cb?: Function) {
            this.privateGet(`/sns/characters/${this.getMemberId()}`, cb)
        },
        getUserNftAssets(cb?: Function) {
            this.privateGet(`/nft/assets/${this.getMemberId()}`, cb);
        },
        getUserPublicCharacters(sharingCode: string | null, cb?: Function) {
            if (sharingCode == null) {
                return
            }
            this.publicGet(`/sns/characters/user/${sharingCode}`, cb)
        },
        getWallet(token: string, cb?: Function) {
            this.privateGet(`/core/wallets/${token}/${this.getMemberId()}`, cb)
        },
        giftNft(nftId: string, otp: string, simpleCode: string, cb?: Function) {
            this.privatePost(`/nft/assets/gift/${this.getMemberId()}/${nftId}/${simpleCode}`, {otp}, cb)
        },
        isFavoriteNft(nftId: string, cb?: Function) {
            this.privateGet(`/nft/favorites/check/${this.getMemberId()}/${nftId}`, cb)
        },
        leaveMessage(sharingCode: string | null, message: string, cb?: Function) {
            if (sharingCode !== null) {
                this.privatePost(`/sns/guestbooks/${sharingCode}/${this.getMemberId()}`, {message}, cb);
            }
        },
        lineLogin(projectCode: string, code: string, redirectUrl: string, cb: Function) {
            fetch(`/api/v6/public/partner/line/login/${projectCode}`, {
                method: 'POST',
                headers: { 'content-type': 'application/json' },
                body: JSON.stringify({
                    code: `${code}`,
                    redirectUrl: `${redirectUrl}`
                })
            })
                .then((res) => {
                    if (res.status === 200) {
                        return res.json()
                    } else {
                        return {
                            returnCode: '500'
                        }
                    }
                })
                .then((cargo) => {
                    if (cargo.returnCode === '000000') {
                        for (let key in cargo.info) {
                            if (cargo.info[key]) {
                                localStorage.setItem(key, cargo.info[key]);
                            }
                        }
                    }
                    cb(cargo)
                })
        },
        lineNotifyBinding(code: string | null, redirectUrl: string, cb?: Function) {
            this.privatePost(`/partner/line/notify/${this.getMemberId()}`, { code, redirectUrl }, cb);
        },
        login(username: string, password: string, cb?: Function) {
            this.publicPost(`/core/sessions/${this.projectCode}`, { username, password }, (cargo: ICargo) => {
                if (cargo.returnCode === '000000') {
                    for(let key in cargo.info)
                        if (cargo.info[key])
                            localStorage.setItem(key, cargo.info[key])
                }
                if (cb !== undefined) {
                    cb(cargo)
                }
            })
        },
        logout(cb?: Function) {
            this.privatePost('/core/sessions/expire', {}, cb)
        },
        makeFtxReservation(strategy: string, amount: number, cb?: Function) {
            this.privatePost(`/partner/ftx/reservations/${this.getMemberId()}`, { strategy, amount }, cb)
        },
        makeNftBid(nftId: string, dueDate: Date, cb?: Function) {
            this.privatePost(`/bid/${this.getMemberId()}`, { nftId, dueDate: moment(dueDate).format("YYYY-MM-DD") }, cb, 7);
        },
        makeNftBidding(nftId: string, idBid: number, biddingAmount: number, cb?: Function) {
            this.privatePost(`/bidding/${this.getMemberId()}`, { nftId, idBid, biddingAmount }, cb, 7);
        },
        mintNftAssets(name: string, description: string, image: string, idNftSeries?: number, cb?: Function) {
            this.privatePost(`/nft/assets/${this.getMemberId()}`, { name, description, image, idNftSeries }, cb);
        },
        postFeedback(message: string, cb?: Function) {
            this.publicPost(`/cs/feedback/${this.projectCode}`, { message }, cb)
        },
        purchasePreSaleNftByStripe(amount: number, stripeToken: string, cb?: Function) {
            this.privatePost(`/nft/pre-sale/stripe/${this.getMemberId()}`, { amount, stripeToken }, cb)
        },
        purchasePreSaleNftByUsdt(amount: number, otp: string, cb?: Function) {
            this.privatePost(`/nft/pre-sale/usdt/${this.getMemberId()}`, { amount, otp }, cb)
        },
        registration(username: string, password: string, cb?: Function) {
            this.publicPost(`/core/members/${this.projectCode}`, { username, password }, (cargo: ICargo) => {
                if (cargo.returnCode === '000000') {
                    for(let key in cargo.info)
                        if (cargo.info[key])
                            localStorage.setItem(key, cargo.info[key])
                }
                if (cb !== undefined) {
                    cb(cargo)
                }
            })
        },
        registrationWithReferral(username: string, password: string, referralCode:string, cb?: Function) {
            this.publicPost(`/core/members/referral-signup`, { username, password, referralCode }, (cargo: ICargo) => {
                if (cargo.returnCode === '000000') {
                    for(let key in cargo.info)
                        if (cargo.info[key])
                            localStorage.setItem(key, cargo.info[key])
                }
                if (cb !== undefined) {
                    cb(cargo)
                }
            })
        },
        registerPledgeByCreditCard(amount: number, stripeToken: string, cb?: Function) {
            this.privatePost(`/investment/pledges/stripe/${this.getMemberId()}`, { amount, stripeToken }, cb)
        },
        registerPledgeByUsdt(amount: number, otp: string, cb?: Function) {
            this.privatePost(`/investment/pledges/usdt/${this.getMemberId()}`, { amount, otp }, cb)
        },
        removeCryptoFavorite(crypto: string, cb?: Function) {
            this.privateDelete(`/core/favorite/cryptos/${this.getMemberId()}/${crypto}`, {}, cb)
        },
        returnNft(nftId: string, cb?: Function) {
            this.privatePut(`/nft/assets/return/${this.getMemberId()}/${nftId}`, {}, cb)
        },
        requestNnegoToUsdt(address: string, amount: number, otp: string, cb?: Function) {
            this.privatePost(`/core/transfer/non-negotiable-usdt/${this.getMemberId()}`, { address, amount, otp }, cb);
        },
        searchNft(keyword: string, cb?: Function) {
            this.publicGet(`/nft/assets/search?keyword=${keyword}`, cb)
        },
        sendOtp(cb?: Function) {
            this.privatePost(`/core/otp/${this.getMemberId()}`, {}, cb);
        },
        submitKyc(image: string, idNo: string, name: string, cb?: Function) {
            this.privatePost(`/kyc/${this.getMemberId()}`, {image, idNo, name}, cb, 7)
            this.privatePut(`/kyc/review/${this.getMemberId()}`, {})
        },
        topupGas(amount: number, stripeToken: string, description?: string, cb?: Function) {
            this.privatePost(`/stripe/charge/gas/${this.getMemberId()}`, {amount: amount * 100, stripeToken, description}, cb);
        },
        tradingNftByGas(nftId: string, otp: string, cb?: Function) {
            this.privatePost(`/nft/assets/trading/${this.getMemberId()}/${nftId}/gas`, {otp}, cb)
        },
        tradingNftByNnego(nftId: string, otp: string, cb?: Function) {
            this.privatePost(`/nft/assets/trading/${this.getMemberId()}/${nftId}/nnego`, {otp}, cb)
        },
        tradingNftByStripe(amount: number, stripeToken: string, nftId: string, cb?: Function) {
            this.privatePost(`/nft/assets/trading/${this.getMemberId()}/${nftId}/stripe`, {amount, stripeToken}, cb)
        },
        tradingNftByUsdt(nftId: string, otp: string, cb?: Function) {
            this.privatePost(`/nft/assets/trading/${this.getMemberId()}/${nftId}/usdt`, {otp}, cb)
        },
        transferGas(simpleCode: string, amount: number | string, otp: string, cb?: Function) {
            this.privatePost(`/core/transfer/gas/${this.getMemberId()}`,
                { simpleCode: simpleCode, amount: Number(amount), otp: otp }, cb);
        },
        transferNnego(simpleCode: string, amount: number | string, otp: string, cb?: Function) {
            this.privatePost(`/core/transfer/non-negotiable/${this.getMemberId()}`,
                { simpleCode: simpleCode, amount: Number(amount), otp: otp }, cb);
        },
        transferUsdt(simpleCode: string, amount: number | string, otp: string, cb?: Function) {
            this.privatePost(`/core/transfer/usdt/${this.getMemberId()}`,
                { simpleCode: simpleCode, amount: Number(amount), otp: otp }, cb);
        },
        updateAvator(avator: string, cb?: Function) {
            this.privatePatch(`/core/profiles/${this.getMemberId()}`, { avator }, cb)
        },
        updateCreatorBanner(bannerUrl: string, cb?: Function) {
            this.privatePut(`/creator/profile/${this.getMemberId()}`, { bannerUrl }, cb, 7)
        },
        updateCreatorIntroduction(introduction: string, cb?: Function) {
            this.privatePut(`/creator/profile/${this.getMemberId()}`, { introduction: introduction }, cb, 7)
        },
        updateFavoriteNft(nftId: string, cb?: Function) {
            this.privatePut(`/nft/favorites/${this.getMemberId()}/${nftId}`, {}, cb)
        },
        updateFtxReservationAmount(idFtxReservation: number, amount: number, cb?: Function) {
            this.privatePatch(`/partner/ftx/reservations/${this.getMemberId()}`, {idFtxReservation, amount}, cb)
        },
        updateGender(gender: string, cb?: Function) {
            this.privatePatch(`/core/profiles/${this.getMemberId()}`, { multiGender: gender }, cb)
        },
        updateMail(mail: string, cb?: Function) {
            this.privatePatch(`/core/profiles/${this.getMemberId()}`, { email: mail }, cb)
        },
        updateNftSellingPrice(nftId: string, selectedSellingStatus: string, sellingPrice: number, cb?: Function) {
            this.privatePatch(`/nft/assets/${this.getMemberId()}/${nftId}`, { status: selectedSellingStatus, sellingPrice }, cb)
        },
        updateNickname(nickname: string, cb?: Function) {
            this.privatePatch(`/core/profiles/${this.getMemberId()}`, { nickname }, cb)
        },
        updateYoutubeUrl(youtubeUrl: string, cb?: Function) {
            this.privatePut(`/creator/profile/${this.getMemberId()}`, { youtubeUrl: youtubeUrl }, cb, 7)
        },
        uploadImageFile(projectCode: string, fileOfBlob: Blob, cb?: Function) {
            const formData = new FormData();
            formData.append('file', fileOfBlob);
    
            fetch(`/api/v6/private/core/files/${projectCode.toLowerCase()}/${this.getMemberId()}`, {
                method: 'POST',
                headers: {
                    'X-Access-Token': window.localStorage.getItem('token') || 'Dummy'
                },
                body: formData
            }).then(res => res.json())   // you can do something with response
            .catch(error => console.error('Error:', error))
            .then((cargo: ICargo) => {
                if (cb !== undefined) {
                    cb(cargo)
                }
            });
        },
        uploadNftImageFile(fileOfBlob: Blob, cb?: Function) {
            const formData = new FormData();
            formData.append('file', fileOfBlob);
    
            fetch(`/api/v6/private/core/files/nft/${this.getMemberId()}`, {
                method: 'POST',
                headers: {
                    'X-Access-Token': window.localStorage.getItem('token') || 'Dummy'
                },
                body: formData
            }).then(res => res.json())   // you can do something with response
            .catch(error => console.error('Error:', error))
            .then((cargo: ICargo) => {
                if (cb !== undefined) {
                    cb(cargo)
                }
            });
        },
        uploadPersonalFile(fileOfBlob: Blob, cb?: Function) {
            const formData = new FormData();
            formData.append('file', fileOfBlob);
    
            fetch(`/api/v6/private/core/files/${this.getMemberId()}`, {
                method: 'POST',
                headers: {
                    'X-Access-Token': window.localStorage.getItem('token') || 'Dummy'
                },
                body: formData
            }).then(res => res.json())   // you can do something with response
            .catch(error => console.error('Error:', error))
            .then((cargo: ICargo) => {
                if (cb !== undefined) {
                    cb(cargo)
                }
            });
        },
    }
}